import { useNavigate, useParams } from 'react-router-dom';
import NewMergeRuleModal from './NewMergeRuleModal';
import ListSelector from '../../components/template/ListSelector';
import api from '../../components/utils/api';
import { useEffect, useState } from 'react';

const MergeRuleSelector = ({ selectedMergeRule, generalModel, onLoaded }) => {
    const navigate = useNavigate()
    const { mergeRuleId } = useParams()
    const [mergeRules, setMergeRules] = useState([])
    useEffect(() => {
        const fetchMergeRules = async () => {
            try {
                const res = await api.get(`/api/general-models/${generalModel.id}/merge-rules`)
                setMergeRules(res.data.merge_rules)
                // land on the original merge rule when none is selected yet
                if (!mergeRuleId) {
                    const original = res.data.merge_rules.find(r => r.name === 'original')
                    if (original) navigate(`/post-action/models/${generalModel.id}/merge-rules/${original.id}/detail`, { replace: true })
                }
            } catch (err) {
                console.error(err)
            } finally {
                onLoaded?.()
            }
        }
        if (generalModel?.id) fetchMergeRules()
    }, [generalModel, mergeRuleId, navigate, onLoaded])
    return (
        <ListSelector
            obejcts={mergeRules}
            selectedObject={selectedMergeRule}
            onClick={(obj) => navigate(`/post-action/models/${generalModel.id}/merge-rules/${obj.id}/detail`)}
            modalContents={<NewMergeRuleModal generalModel={generalModel} mergeRules={mergeRules} />}
            addNewString={' Add a Merge Rule'}
        />
    )
}

export default MergeRuleSelector